import { styled } from '../../../Utilities';
import { ShimmerGapBase } from './ShimmerGap.base';
import { getStyles } from './ShimmerGap.styles';
export var ShimmerGap = styled(ShimmerGapBase, getStyles, undefined, {
    scope: 'ShimmerGap',
});
//# sourceMappingURL=ShimmerGap.js.map